import React, { useState, useEffect } from 'react'
import MapDetails from '../home/LoggersetMap/Info/MapDetails'
import MapParentContainer from '../home/LoggersetMap/MapParentContainer'
import { LoggersetDetailsDto } from '../../models/Pharse2/LocationMap';
import { GraphForm, GraphFormVal } from '../../models/Pharse2/Graph';
import OverviewRecord from '../Overview/OverviewRecord';
import { AALocationDetailsDto } from './../../models/Pharse2/Overview';
import { store } from '../../stores/store';
import LoadingComponent from '../../components/LoadingComponent';
import { observer } from 'mobx-react-lite';
import FilterHeader from '../../components/Graph/FilterHeader/FilterHeader';
import GeneralButton from '../../components/Button/GeneralButton';
import { ProjectDistinct } from "../../models/Pharse2/LocationMap";
import ReactDOM from 'react-dom';
import TidalDisplayContainer from '../../components/Weather/TidalDisplayContainer';
import RainfallDisplayContainer from '../../components/Weather/RainfallDisplayContainer';
import { useStore } from '../../stores/store';

export default observer(function DashboardPage() {
	const { userStore } = useStore();
	const { CheckIfHkiaEmail } = userStore;
	const [detailsInfo, setDetailsInfo] = useState<any>();
	const [isInfoOpen, setInfoOpen] = useState<boolean>(false);
	const [form, setForm] = useState<GraphForm>(new GraphFormVal())
	const [horizontalView, setHorizontalView] = useState<boolean>(window.innerWidth > 1024 ? true : false);
	const [projectoptions, setprojectoptions] = useState<string>();

	function setprojectoptionsnamevoid(data: string) {
		setprojectoptions(data)
	}
	const [domReady, setDomReady] = React.useState(false)

	React.useEffect(() => {
		setDomReady(true)
	}, [])
	return (

		<div className="pageParentDiv">
			{domReady && ReactDOM.createPortal(<button onClick={() => setHorizontalView(!horizontalView)} >
				<img src="/assets/button/rotate.svg" className="w-8" />
			</button>, document.getElementById('navportal') as HTMLElement)}
			<MapDetails detailsInfo={detailsInfo} isOpen={isInfoOpen} setOpen={setInfoOpen} form={form} />
			<div className={`${horizontalView ? "horizontal-container" : "vertical-container"}`}>
				{/* Map Container */}
				<div className={`${horizontalView ? 'w-1/2' : 'w-full'} z-0`}>
					<MapParentContainer form={form} setForm={setForm} setInfoOpen={setInfoOpen} setDetailsInfo={setDetailsInfo} setprojectoptionsname={setprojectoptionsnamevoid} />
				</div>

				{/* Right/Bottom Section */}
				<div className={`${horizontalView ? 'w-1/2' : 'w-full'} flex flex-col gap-4`}>
					{/* Overview Record */}
					<OverviewRecord setForm={setForm} setInfoOpen={setInfoOpen} setDetailsInfo={setDetailsInfo} projectoptionsname={projectoptions} />
				</div>

			</div>

			{CheckIfHkiaEmail() && <div className={`${horizontalView ? "horizontal-container mt-4" : "vertical-container"}`}>
				<div className={`${horizontalView ? 'w-1/2' : 'w-full'} flex flex-col gap-4`}>
					{/* Weather Display Containers */}
					{/* Rainfall Display Container - RF014 (Hong Kong International Airport) */}
					<RainfallDisplayContainer
						stationId="RF014"
						lang="en"
						autoRefresh={true}
						refreshInterval={300000} // 5 minutes (API updates every 5 minutes)
					/>

				</div>
				{/* Tidal Display Container */}
				<div className={`${horizontalView ? 'w-1/2' : 'w-full'} flex flex-col gap-4`}>
					<TidalDisplayContainer
						station="CLK"
						stationName="Hong Kong International Airport (Chek Lap Kok)"
						autoRefresh={true}
						refreshInterval={300000} // 5 minutes
					/>

				</div>
			</div>
			}

		</div>
	)
})
